/**
 * PixelFormat enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file PixelFormat.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum PixelFormat {
  R8G8B8 = 1,
  B8G8R8 = 2,
  R8G8B8A8 = 3,
  B8G8R8A8 = 4,
  A1R5G5B5 = 5,
  R5G6B5 = 6,
  Depth16 = 7,
  DXT1 = 8,
  DXT3 = 9,
  DXT5 = 10
};